import React from "react";
import { Container, Row } from "react-bootstrap";
import { CgEditMarkup } from "react-icons/cg";
const Terms=()=>{
return(
    <div>

            <center>
        <h1 className="heading">Terms and Policy</h1>
        </center>
        <Container>
        <Row className="terms">
        <p>Welcome to Itok, a voice assistant app that provides speech to text functionality using your device’s microphone and speaker. These Terms of Service govern your use of the Itok app and any related services.</p>
<ol>
<li><strong>Use of the App</strong> – By using Itok, you agree to these Terms of Service. You must be at least 13 years of age to use the app.</li>



<li><strong>Speech to Text</strong> – Itok uses your device’s microphone to record your voice and convert it into text. The app processes this data on your device and may send it to our servers for further processing. We do not store your voice data on our servers, except to improve the app’s performance and accuracy.</li>



<li><strong>Dictation</strong> – Itok uses your device’s speaker to dictate responses to your voice commands. These responses may be generated by the app or retrieved from external sources. We do not guarantee the accuracy or completeness of these responses.</li>



<li><strong>Language Support</strong> – Itok uses the default language of your device to set the language of the app. You may change the language settings in the app’s settings menu.</li>



<li><strong>Data Storage</strong> – Itok stores your email address and mobile number in Firebase, a cloud-based database platform. We use this information to provide you with support and to improve the app’s performance. We do not share your data with third parties, except as required by law.</li>



<li><strong>User Conduct</strong> – You agree to use Itok in a lawful and ethical manner. You must not use the app to harass, defame, or discriminate against any person or group. You must not use the app for any illegal or unauthorized purpose.</li>



<li><strong>Modifications – </strong>We reserve the right to modify or update these Terms of Service at any time. We will notify you of any changes by posting the new terms on our website or within the app. Your continued use of the app after the changes have been made indicates your acceptance of the new terms.</li>



<li>D<strong>isclaimer of Warranties</strong> – Itok is provided “as is” without any warranties or guarantees. We do not guarantee that the app will be error-free or uninterrupted. We are not responsible for any damages arising from your use of the app.</li>



<li><strong>Limitation of Liability</strong> – We are not liable for any indirect, incidental, or consequential damages arising from your use of Itok. Our liability is limited to the amount you paid for the app or service, if any.</li>
</ol>

        </Row>
        </Container>
    </div>
)}

export default Terms